export const state = () => ({
    carpeta_items: [],
    observaciones_carpeta: [],
    plazos: [],
    categorias_aceptadas: [],
    form_proyecto: {
        id: {
            value: null,
            required: false,
        },
        departamento:{
            value:null,
            required:false,
        },
        tipo_institucion:{
            value:null,
            required:false,
        },
        name_institucion:{
            value:null,
            required:false,
        },
        institucion: {
            value: null,
            state: null,
            message: 'Alcaldia es obligatoria',
            required: true
        },
        nombre_proyecto: {
            value: null,
            state: null,
            message: 'Nombre es obligatorio',
            required: true
        },
        foto_dui: {
            value: null,
            state: null,
            message: 'Escaneo carta solicitud es requerida *',
            required: true
        },
        dui_doc: {
            value: null,
            state: null

        },
        tipo_proyecto: {
            value: null,
            state: null,
            message: 'Seleccione tipo proyecto',
            required: true
        },
        id_project_request: {
            value: null,
            state: null,
            message: 'Seleccione tipo proyecto',
            required: true
        },
        direccion_extra: {
            value: null,
            state: null,
            message: 'Dirección es obligatoria',
            required: true
        },
        id_estado: {
            value: null,
            required: false,
        },
        id_verification_reception: {
            value: null,
            required: false,
        },
        id_verification_cost: {
            value: null,
            required: false,
        },
        tenencia_tierra: {
            value: null,
            state: null,
            message: 'Dirección es obligatoria',
            required: true
        },
        dui_responsable: {
            value: null,
            state: null,
            message: 'Dui es obligatorio',
            required: true
        },
        id_responsable: {
            value: null,
            required: true
        },
        nombre_responsable: {
            value: null,
            required: true
        },
        correo_electronico: {
            contacto: null,
            id_contacto: null,
            state: null,
            message: 'Correo es obligatorio',
            required: false,
        },
        lat_lng: {
            value: [],
            required: false
        },

        costo_total_presupado: {
            value: null,
            required: false
        },
        plazo_estimacion: {
            value: null,
            state: null,
            message: null,
            required: true
        },
        idProccessMethod: {
            value: null,
            state: null,
            message: null,
            required: false
        },
        idProccessMethodType: {
            value: null,
            state: null,
            message: null,
            required: false
        },
    },
    proyecto_data: {
        institucion: {},
        alcalde: {},
        responsable: {},
        plazo_estimacion: {},
        idProccessMethod: {},
        idProccessMethodType: {},
        poligono:[],
        tecnico_asignado:{},
        indirect_cost_percentage: 0,
        utility_percentage: 0,
        iva_percentage: 0
    },
    presupuestos: [],
    actividades: [],
    actividad: {
        id: {
            value: null,
            required: false
        },
        index: {
            value: null,
            required: false
        },
        actividad: {
            value: null,
            state: null,
            message: 'El valor no puede estar vacío',
            required: true,
            type: 'Number'
        },
        cantidad: {
            value: null,
            state: null,
            message: 'El valor no puede estar vacío',
            required: true,
            type: 'Number'
        },
        precio_unitario: {
            value: null,
            state: null,
            message: 'El valor no puede estar vacío',
            required: true,
            type: 'Number'
        },
    },
    archivo: {
        required: true,
        state: null,
        value: null,
        message: 'es obligatorio'
    },
    stepper_value: 1,
    showCreatePerson: false
})
